export default __webpack_public_path__ + "static/media/ID_SCHOOL_MARLO.6d92941d.jpg";